<script setup lang="ts">
import { useData } from '../../_composables/useData';
import ExpandableCard from '@components/util/ExpandableCard.vue';

const { hotelPackage } = useData();
const { isMobile } = useSize();

const amenities = computed(() =>
    hotelPackage.value.amenities.filter(am => am.title.length < 30)
);
</script>
<template>
    <div v-if="amenities.length">
        <mr-typography size="x-large" weight="700" type="h2" class="title">
            امکانات و ویژگی‌ها
        </mr-typography>
        <ExpandableCard
            :default-height="isMobile ? 224 : 168"
            more-title="امکانات بیشتر"
            :data-value="amenities.length"
        >
            <div class="amenities-content">
                <div
                    v-for="amenity in amenities"
                    :key="amenity.title"
                    class="amenity-item"
                >
                    <mr-icon :icon="amenity.icon" color="black" size="small" />
                    <mr-typography weight="500">
                        {{ amenity.title }}
                    </mr-typography>
                </div>
            </div>
        </ExpandableCard>
    </div>
</template>
<style scoped lang="scss">
.title {
    margin-bottom: 8px;
    margin-top: 0;
    @include mobile-only {
        margin-bottom: 0;
    }
}
.amenities-content {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    @include mobile-only {
        gap: 8px;
    }
    .amenity-item {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-basis: calc(25% - 9px);
        max-width: calc(25% - 9px);
        @include mobile-only {
            flex-basis: calc(50% - 4px);
            max-width: calc(50% - 4px);
        }
    }
}
</style>
